import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ContentProvider } from './contexts/ContentContext';
import { ScrollToTop } from './components/shared';
import ScrollPerf from './components/ScrollPerf';
import SiteNotifications from './components/SiteNotifications/SiteNotifications';
import PageFallback from './components/PageFallback';

// Ana sayfa rotaları (route-level code splitting)
const Home = lazy(() => import('./pages/Home'));
const Packages = lazy(() => import('./pages/Packages'));
const Bayilik = lazy(() => import('./pages/Bayilik'));
const Kurulum = lazy(() => import('./pages/Kurulum'));
const Hakkimizda = lazy(() => import('./pages/Hakkimizda'));
const Sss = lazy(() => import('./pages/Sss'));
const TitanIptvRehber = lazy(() => import('./pages/TitanIptvRehber'));
const NotFound = lazy(() => import('./pages/NotFound'));

// Admin rotaları - son kullanıcıya hiç gönderilmesin
const AdminLogin = lazy(() => import('./admin/AdminLogin'));
const AdminDashboard = lazy(() => import('./admin/AdminDashboard'));

function App() {
  return (
    <HelmetProvider>
      <ContentProvider>
        <Router>
          <ScrollToTop />
          <ScrollPerf />
          <SiteNotifications />
          <Suspense fallback={<PageFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/paketler" element={<Packages />} />
              <Route path="/bayilik" element={<Bayilik />} />
              <Route path="/kurulum" element={<Kurulum />} />
              <Route path="/hakkimizda" element={<Hakkimizda />} />
              <Route path="/sss" element={<Sss />} />
              <Route path="/titan-iptv-satin-al" element={<TitanIptvRehber />} />
              <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </Router>
      </ContentProvider>
    </HelmetProvider>
  );
}

export default App;
